module.exports = __webpack_public_path__ + "img/productlb2.fc737c15.png";